import { ObservableArray, View } from "binder"
import { FirstCounting, ITab, ProductsList, SecondCounting, ThirdCounting, WarehouseKeepingDetailViewModel } from "./warehouseKeepingDetail-viewModel"

export class WarehouseKeepingDetailView extends View<WarehouseKeepingDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-611566F7-CF5F-4F6A-B610-3A7A0249E689"
    }
    loadHtml(): string {
        let element = require('./warehouseKeepingDetail.html').default;
        let style = require('./warehouseKeepingDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set tabs(v: ObservableArray<ITab>) { this._tabs = v; } public get tabs(): ObservableArray<ITab> { return this._tabs;} private _tabs: ObservableArray<ITab>;
    public set selectedTab(v: ITab) { this._selectedTab = v; } public get selectedTab(): ITab { return this._selectedTab;} private _selectedTab: ITab;
    public set keepingId(v: string) { this._keepingId = v; } public get keepingId(): string { return this._keepingId;} private _keepingId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set productsList(v: ProductsList) { this._productsList = v; } public get productsList(): ProductsList { return this._productsList;} private _productsList: ProductsList;
    public set firstCounting(v: FirstCounting) { this._firstCounting = v; } public get firstCounting(): FirstCounting { return this._firstCounting;} private _firstCounting: FirstCounting;
    public set secondCounting(v: SecondCounting) { this._secondCounting = v; } public get secondCounting(): SecondCounting { return this._secondCounting;} private _secondCounting: SecondCounting;
    public set thirdCounting(v: ThirdCounting) { this._thirdCounting = v; } public get thirdCounting(): ThirdCounting { return this._thirdCounting;} private _thirdCounting: ThirdCounting;

    closePopup(){
        this.dataContext.closePopup();
    }

}
